import DashboardTransportLogistics from './DashboardTransportLogistics';
import { DashboardControlsProvider } from 'contexts/Dashboard/useDashboardControls';
import ViewActionsBar from '../../components/Dashboard/ViewActionsBar';
import TLFilterBar from './TLFilterBar';
import { DefaultTLWidgets, TLWidgetsEnum } from './utils';
import { CaseTypeEnum } from 'api/model';

const FollowUpPage = () => {
  return (
    <DashboardControlsProvider<TLWidgetsEnum>
      storageKey="TransportLogistics"
      defaultWidgets={DefaultTLWidgets}
    >
      <TLFilterBar />
      <ViewActionsBar
        showSendToFieldTestersModal
        excludeCaseTypes={[CaseTypeEnum.TestDrive]}
      />
      <DashboardTransportLogistics />
    </DashboardControlsProvider>
  );
};

export default FollowUpPage;
